<div class="row justify-content-center">
    <div class="col-lg-8">
        <div *ngIf="user" class="card">
            <div class="card-body">
                <div class="form-body">
                    <h3 class="card-title">Cuentas secundarias</h3>
                    <div class="row p-t-20">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="control-label">Email</label>
                                <input [(ngModel)]="account.subaccountEmail" type="text" class="form-control" placeholder="Ingrese el email de la cuenta secundaria">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="control-label">Permisos</label>
                                <select [(ngModel)]="account.permissionType" class="form-control custom-select">
                                    <option value="none">Ninguno</option>
                                    <option value="limited">Limitado</option>
                                    <option value="full">Completo</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="control-label">Agregar usos/créditos</label>
                                <input [(ngModel)]="addingCredits" min="0" type="number" (ngModelChange)="checkMinCredits()" class="form-control">
                                <span *ngIf="!user.isUnlimited" ><small>*Los créditos asignados se descontarán de su cuenta</small></span>
                            </div>
                        </div>

                        <div *ngIf="user.isUnlimited" class="col-md-6">    
                              <div class="form-group">
                                <label >Tilde para uso sin restricciones de créditos</label>
                                  <input type="checkbox" [(ngModel)]="isUnlimited" id="unlimited" checked>
                                  <label for="unlimited">Usos/créditos ilimitados</label>
                              </div>
                        </div>


                        <div class="col-12">
                            <h5>🔐Tipos de permisos</h5>
                            <p class="mb-1"><small><b>•Ninguno:</b><br> El usuario solo accede a <b>sus propias evaluaciones</b></small></p>
                            <p class="mb-1"><small><b>•Limitado:</b><br> El usuario accede a <b>sus evaluaciones y a las de la cuenta principal (es decir, la cuenta a la que pertenece).</b></small></p>
                            <p class="mb-1"><small><b>•Completo:</b><br> El usuario accede a <b>sus evaluaciones, las de la cuenta principal y de todas las cuentas secundarias</b> asociadas.</small></p>
                        </div>

                    </div>
                    

                    <div class="col-6 px-0 mt-3">
                        <div class="demo-switch-title">Personalizar envío</div>
                        <div class="switch">
                          <label>
                            <input (click)="defaultEmail =! defaultEmail; initEditor()" [ngModel]="!defaultEmail" type="checkbox"  ><span class="lever switch-col-indigo"></span>
                          </label>
                          <label class="mytooltip"><b class="text-info">?</b><span class="tooltip-content4">Aquí podrá personalizar el cuerpo y asunto del email a enviar (usted no visualiza los datos de acceso pero estos son enviados al final del email).</span></label>
                        </div>
                    </div>
                    
                    <div *ngIf="editor && !defaultEmail" class="NgxEditor__Wrapper m-b-40 col-12">

                        <div class="col-12">
                            <div class="form-group">
                                <label class="control-label">Asunto</label>
                                <input [(ngModel)]="subject" type="text" class="form-control" placeholder="Asunto">
                            </div>
                        </div>

                        <ngx-editor-menu [editor]="editor"> </ngx-editor-menu>
                        <ngx-editor 
                            [editor]="editor" 
                            [(ngModel)]="html" 
                            [placeholder]="'Escriba su texto...'"
                            [ngModelOptions]="{standalone: true}">
                        </ngx-editor>
                    </div>

                    <button type="button" class="btn btn-info btn-rounded waves-effect pull-right" (click)="handleCreateAccount()" >{{editingId ? 'Actualizar' : 'Crear'}} cuenta</button>

                </div>
            </div>
        </div>
    </div>


    <div class="col-lg-8">
        <div *ngIf="user" class="card">
            <div class="card-body">
                    <h4>Cuentas creadas {{accounts.length}}/{{user.subaccountLimit}}</h4>

                    <table class="w-100" >
                        <tr>
                            <th>
                                Email
                            </th>
                            <th>
                                Permisos
                            </th>
                            <th>
                                Acciones
                            </th>
                        </tr>
                        <tr *ngFor="let account of accounts" >
                            <td>
                                {{account.subaccountEmail}}
                            </td>
                            <td>
                                {{account.permissionType == 'none' ? 'Ninguno' : account.permissionType == 'limited' ? 'Limitado' : 'Completo'}}
                            </td>
                            <td>
                                <button title="Eliminar" type="button" class="btn btn-sm btn-icon btn-pure btn-outline delete-row-btn" (click)="handleDeleteAccount(account)" ><i class="fa fa-trash" aria-hidden="true"></i></button>
                                <button title="Editar" type="button" class="btn btn-sm btn-icon btn-pure btn-outline delete-row-btn" (click)="handleEditAccount(account)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        </tr>
                    </table>

            </div>
        </div>

    </div>
</div>


<div class="modal fade new-user-modal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" style="display: none;">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <div class="form-group ">
                    <div class="col-12">
                        <h5>El usuario no existe. Por favor ingrese una contraseña para crear uno nuevo.</h5>
                        <div class="form-group">
                            <label class="control-label">Contraseña</label>
                            <input [(ngModel)]="newPassword" type="text" class="form-control" placeholder="Ingrese la contraseña para la nueva cuenta">
                        </div>
                        <button type="button" class="btn btn-info btn-rounded waves-effect pull-right" (click)="createAccount()" >Crear usuario</button>

                    </div>
                </div> 
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>